import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import GlobalStyle from './styles/global';

import Routes from './routes';

import AppProvider from './hooks';
import { apolloClient } from './services/apollo';


function App() {
  return (
    <Router>
      <GlobalStyle />

      <AppProvider>
        <ApolloProvider client={apolloClient}>
          <Routes />
        </ApolloProvider>
      </AppProvider>
    </Router>
  );
}

export default App;
